import { getWebsiteNewConfigurePath } from 'domains/website/website.paths'

export const getTemplateDeploymentLink = ({
  templateGitRepoUrl,
  templateSlug,
  accountSlug,
  envVars = [],
}: {
  templateGitRepoUrl: string
  templateSlug: string
  accountSlug?: string
  envVars?: string[]
}) => ({
  pathname: getWebsiteNewConfigurePath(accountSlug, true),
  query: {
    source: templateGitRepoUrl,
    template: templateSlug,
    ...(envVars.length && { env: envVars.join(',') }),
  },
})

export const buildURL = (baseUrl: string, query?: Record<string, any>) => {
  const url = new URL(baseUrl)
  if (query) {
    url.search = new URLSearchParams(query).toString()
  }
  return url.toString()
}

export const openInNewTab = (url: string) => open(url, '_blank')?.focus()
